import { TextField, Typography } from "@mui/material"
import React, { Dispatch, SetStateAction, useCallback, useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import { DeleteDialog } from "../../../../../../../components/dialog/DeleteDialog"
import { resolveUrl } from "../../../../../../../core/services/http-service"
import { pagesUrl } from "../../../../../../../core/appConstants"
import { BSVariantContext } from "../../../../../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { ProjectContext } from "../../../../../../../core/context/project/ProjectContext"
import { BSVariant } from "../../../../../../../core/dto/beem-shot/BSVariant/BSVariant"
import { validateNameToDelete } from "../../../../../../../core/hooks/form/validation"
import { ErrorContext } from "../../../../../../../components/layout/error-snackbar"

interface IProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  bsVariant?: BSVariant
}

export function DeleteVariantDialog({ open, setOpen, bsVariant }: Readonly<IProps>): React.JSX.Element {
  const navigate = useNavigate()

  const openErrorSnackbar = useContext(ErrorContext)
  const { project } = useContext(ProjectContext)
  const { deleteVariant } = useContext(BSVariantContext)

  const [error, setError] = useState<Record<string, string | undefined>>({})
  const [nameToDelete, setNameToDelete] = useState<string>("")
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  const handleChangeDeleteDialog: (event: React.ChangeEvent<HTMLInputElement>) => void = useCallback((event) => {
    const target = event.target

    setError({})
    setNameToDelete(target.value)
  }, [])

  const onDeleteVariant: () => void = useCallback(() => {
    if (!bsVariant?.id) {
      openErrorSnackbar(new Error("Il n'y a pas d'estimation sélectionnée à supprimer"))
      return
    }

    const { isValid, newError } = validateNameToDelete(nameToDelete, bsVariant?.name)
    if (!isValid) {
      setError(newError)
    } else {
      setIsSubmitting(true)
      deleteVariant()
        .then(() => {
          setOpen(false)
          navigate(resolveUrl(pagesUrl.PROJECT_PAGE_DETAIL, [project?.id]))
        })
        .finally(() => {
          setIsSubmitting(false)
        })
    }
  }, [bsVariant?.id, bsVariant?.name, deleteVariant, nameToDelete, navigate, openErrorSnackbar, project?.id, setOpen])

  return (
    <DeleteDialog
      id="delete-variant-dialog"
      title={`Suppression de l'estimation "${bsVariant?.name}"`}
      contentText={
        <>
          <Typography variant="body1" sx={{ fontSize: 19 }}>
            Pour confirmer la suppression, tapez "{bsVariant?.name}" ci-dessous (sans les guillemets)
          </Typography>
          <TextField
            required
            id="variantNameToDelete"
            onChange={handleChangeDeleteDialog}
            value={nameToDelete}
            variant="outlined"
            fullWidth
            error={!!error.nameToDelete}
            helperText={error.nameToDelete}
            sx={{
              mt: 2,
              input: { cursor: "text" },
            }}
          />
        </>
      }
      handleClose={() => setOpen(false)}
      action={onDeleteVariant}
      isOpen={open}
      isSubmitting={isSubmitting}
    />
  )
}
